import AnonymousDonorAPI from './api'
import { objectToCamelCase, objectToSnakeCase } from '../utils'
import options from './options'

export default class AnonymousDonor {
  static options = options
  static api = AnonymousDonorAPI.create(AnonymousDonor)
  static readOnlyFields = ['id', 'currency', 'status', 'datetimeCreated']
  constructor({
    id = '',
    datetimeCreated = '',
    organization = null,
    orgRelationship = '',
    firstName = '',
    lastName = '',
    email = '',
    employeeId = '',
    otherRelationship = '',
    zipCode = '',
    isMonthlyDonor = null,
    magicToken = null,
  } = {}) {
    Object.assign(this, {
      id,
      datetimeCreated,
      organization,
      orgRelationship,
      firstName,
      lastName,
      email,
      employeeId,
      otherRelationship,
      zipCode,
      isMonthlyDonor,
      magicToken,
    })
  }

  static create(opts) {
    return new AnonymousDonor(opts)
  }

  static fromAPI(json = {}) {
    return new AnonymousDonor(objectToCamelCase(json))
  }

  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The readOnlyFields are always excluded.
   **/
  static toAPI(donor, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = donor[field]
      })
    } else {
      data = donor
    }

    //
    excludeFields = [...AnonymousDonor.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }
}
